module.exports = __webpack_public_path__ + "img/76052.87ce0a90.svg";